jQuery(function ($) {
  const $root = $('.jw-combine-metre-outter-wrapper').first();
  if (!$root.length) return;

  /* ---------------- Price calc ---------------- */
  function jw_combine_metre_cal_total_price() {
    const $unitPrice      = $root.find('#jw-combine-metre-per-qtr-price .buckscc-money');
    const $oneMetrePrice  = $root.find('#jw-combine-metre-one-metre-price-main');
    const $realQuantity   = $root.find('#jw-combine-metre-shopify_quantity input[name="quantity"]');
    const $priceDynamic   = $root.find('#jw-combine-metre-dynamic_price');
    const $currencyLabel  = $('.bucks-selected'); // usually global

    if (!$unitPrice.length || !$realQuantity.length) return;

    const unitCount = parseInt($realQuantity.val(), 10) || 0;

    // Raw like: "$5.62 AUD", "€7,80 EUR"
    const raw = ($unitPrice.text() || '').trim();
    const numMatch = raw.match(/[\d.,]+/);
    if (!numMatch) return;

    let numStr = numMatch[0];
    // Handle either "7,80" or "8,860.50"
    if (numStr.includes(',') && !numStr.includes('.')) {
      numStr = numStr.replace(',', '.');
    } else {
      numStr = numStr.replace(/,/g, '');
    }

    const unitPrice = parseFloat(numStr) || 0; // quarter-metre price
    const total     = unitPrice * unitCount;
    const perMetre  = unitPrice * 4;

    const currencySymbol = (raw.match(/^[^\d]+/) || [''])[0].trim();
    const currencyCode   = ($currencyLabel.text() || '').trim(); // e.g. AUD/EUR

    let formattedTotal   = `${currencySymbol}${total.toFixed(2)} ${currencyCode}`;
    let formattedPerM    = `${currencySymbol}${perMetre.toFixed(2)} ${currencyCode}`;

    // Simple EUR tweak to use comma decimal (kept from your code)
    if (currencyCode === 'EUR') {
      formattedTotal = formattedTotal.replace('.', ',');
      formattedPerM  = formattedPerM.replace('.', ',');
    }

    $priceDynamic.text(formattedTotal);
    $oneMetrePrice.text(formattedPerM);
  }

  /* --------------- Quantity controls --------------- */
  function jw_combine_metre_init_quantity() {
    const $meterDisplay    = $root.find('#jw_fabric_meter');
    const $yardDisplay     = $root.find('#jw_fabric_yard');
    const $fakeQtyInput    = $root.find('#jw-combine-metre-shopify_quantity_fake input[name="quantity_fake"]');
    const $realQtyInput    = $root.find('#jw-combine-metre-shopify_quantity input[name="quantity"]');
    const $minusBtn        = $root.find('#jw-combine-metre-shopify_quantity_fake .minus');
    const $plusBtn         = $root.find('#jw-combine-metre-shopify_quantity_fake .plus');

    const STEP = 0.25;
    const MIN  = 0.25;
    const M_TO_YARD = 1.094;

    function jw_combine_metre_update_values(newMeter) {
      const safeMeter   = Math.max(MIN, Math.round(newMeter / STEP) * STEP);
      const yards       = (safeMeter * M_TO_YARD).toFixed(2);
      const realQuarters= Math.round(safeMeter / STEP); // Shopify integer (quarters)

      $meterDisplay.text(safeMeter.toFixed(2));
      $yardDisplay.text(yards);
      $fakeQtyInput.val(safeMeter.toFixed(2));
      $realQtyInput.val(realQuarters);

      jw_combine_metre_cal_total_price();
    }

    $minusBtn.on('click', function () {
      const current = parseFloat($meterDisplay.text()) || MIN;
      if (current > MIN) jw_combine_metre_update_values(current - STEP);
    });

    $plusBtn.on('click', function () {
      const current = parseFloat($meterDisplay.text()) || MIN;
      jw_combine_metre_update_values(current + STEP);
    });

    $fakeQtyInput.on('blur', function () {
      const val = parseFloat($(this).val());
      jw_combine_metre_update_values(isNaN(val) ? MIN : val);
    });
  }

  /* --------------- Variant / currency changes --------------- */
  const DELAY_MS = 1000;
  $root.on('click', '.product-form__swatch__item--button', function () {
    setTimeout(jw_combine_metre_cal_total_price, DELAY_MS);
  });

  /* --------------- Grey out Add to Cart until Width is picked --------------- */
  // Width renders with no option pre-selected (see product-options.liquid's
  // skip_preselect_option), so <variant-radios>'s own currentVariant stays
  // unresolved until Width is chosen - not just on load, but after every
  // subsequent option change too (e.g. picking a Colour before Width).
  // "Not selected yet" isn't the same as "sold out" though: onVariantChange's
  // own setUnavailable() branch (triggered whenever currentVariant is
  // unresolved) swaps the button copy to "Unavailable" and hides the price,
  // which are meant for a genuinely missing variant combo. We undo that and
  // put back "Add to cart" (disabled) whenever the reason is just an
  // unpicked Width, and we have to redo this on every variant change, since
  // onVariantChange() re-applies setUnavailable() each time it re-runs.
  function jw_combine_metre_fix_width_unresolved_state(variantsEl) {
    const hasUnselectedWidth =
      $root.find('input[name="Width"]').length > 0 &&
      $root.find('input[name="Width"]:checked').length === 0;

    if (!hasUnselectedWidth || variantsEl.currentVariant) return;

    const $priceContainer = $('#price-' + variantsEl.uniqueId);
    $priceContainer.removeClass('visibility-hidden');

    const $addButtonText = $root.find('[name="add"] > span').first();
    if ($addButtonText.length && window.theme && window.theme.t) {
      $addButtonText.text(window.theme.t.add_to_cart);
    }
  }

  function jw_combine_metre_init_width_guard() {
    const variantsEl = $root
      .find('variant-radios, variant-selects, variant-mixed-inputs')
      .get(0);

    if (!variantsEl || typeof variantsEl.onVariantChange !== 'function') return;

    // onVariantChange() normally only runs in response to a 'change' event,
    // never automatically on page load, so run it once here to establish
    // the initial disabled/price state.
    const hasUnselectedWidthOnLoad =
      $root.find('input[name="Width"]').length > 0 &&
      $root.find('input[name="Width"]:checked').length === 0;

    if (hasUnselectedWidthOnLoad) {
      variantsEl.onVariantChange();
      jw_combine_metre_fix_width_unresolved_state(variantsEl);
    }

    // Keep re-applying the fix on every later variant change too (e.g.
    // switching Colour while Width is still unpicked), not just at init.
    variantsEl.addEventListener('variants:change', function () {
      jw_combine_metre_fix_width_unresolved_state(variantsEl);
    });
  }

  /* --------------- Init --------------- */
  jw_combine_metre_init_quantity();
  jw_combine_metre_init_width_guard();
  setTimeout(jw_combine_metre_cal_total_price, 800); // after currency plugins

  jw_combine_metre_initCurrencyChangeListener();
    function jw_combine_metre_initCurrencyChangeListener() {
      // When user changes the dropdown manually
        $('#bucksSelector').on('change', function () {
          // Run price calculation after a short delay to let the app update DOM
          setTimeout(jw_combine_metre_cal_total_price, 100);
        });
      
        // When user clicks currency list (desktop UI)
        $(document).on('click', '.converterTriggers', function () {
          // Run price calculation after currency app switches value
          setTimeout(jw_combine_metre_cal_total_price, 100);
        });
      }



});
